import type { StatusMap } from "@vixio/ui";

export const KIND: Record<string, string> = {
  senha: "Senha",
  chave_api: "Chave de API",
  conta_servico: "Conta de serviço",
  banco_de_dados: "Banco de dados",
  certificado: "Certificado",
  nota_segura: "Nota segura",
  outro: "Outro",
};

export const ALERT: StatusMap = {
  ok: { label: "em dia", tone: "ok" },
  vence_em_breve: { label: "vence em breve", tone: "warn" },
  vencida: { label: "vencida", tone: "crit" },
  rotacao_em_breve: { label: "girar em breve", tone: "warn" },
  rotacao_atrasada: { label: "rotação atrasada", tone: "crit" },
  revogada: { label: "revogada", tone: "neutral" },
};

export const ACTION: Record<string, string> = {
  created: "Criou",
  revealed: "Revelou",
  rotated: "Girou o segredo",
  shared: "Compartilhou",
  unshared: "Tirou o compartilhamento",
  updated: "Editou",
  revoked: "Revogou",
};

export const ROLE_LABEL: Record<string, string> = {
  owner: "Proprietário", admin: "Administrador", manager: "Gestor", member: "Equipe", partner: "Parceiro", client: "Cliente", viewer: "Leitura",
};

export interface VaultItem {
  id: string;
  org_id: string;
  title: string;
  kind: string;
  system_name: string | null;
  url: string | null;
  username: string | null;
  notes: string | null;
  tags: string[];
  min_role: string | null;
  status: "ativo" | "revogado";
  current_version: number;
  expires_at: string | null;
  rotate_every_days: number | null;
  last_rotated_at: string;
  responsible_person_id: string | null;
  origin_type: string | null;
  origin_id: string | null;
  alert_state: string;
  last_revealed_at: string | null;
  created_at: string;
  created_by: string | null;
  updated_at: string;
}

export interface Share {
  id: string;
  item_id: string;
  grantee_role: string | null;
  grantee_user: string | null;
  created_at: string;
}

export interface AccessLog {
  id: number;
  item_id: string;
  action: string;
  actor: string | null;
  version: number | null;
  reason: string | null;
  created_at: string;
}

type U = string;
declare module "@vixio/data" {
  interface RpcRegistry {
    "credentials.create_item": {
      args: {
        p_org: U; p_title: string; p_secret: string; p_kind?: string; p_username?: string | null; p_url?: string | null; p_system_name?: string | null;
        p_notes?: string | null; p_min_role?: string | null; p_expires_at?: string | null; p_rotate_every_days?: number | null; p_responsible_person?: U | null;
        p_origin_type?: string | null; p_origin_id?: U | null; p_tags?: string[];
      };
      returns: U;
    };
    "credentials.update_item": { args: { p_item: U; p_patch: Record<string, unknown> }; returns: null };
    "credentials.reveal": { args: { p_item: U; p_reason?: string | null }; returns: { item_id: U; title: string; username: string | null; url: string | null; secret: string; version: number; expired: boolean } };
    "credentials.rotate_secret": { args: { p_item: U; p_new_secret: string; p_expires_at?: string | null }; returns: number };
    "credentials.share": { args: { p_item: U; p_role?: string | null; p_user?: U | null }; returns: U };
    "credentials.unshare": { args: { p_share: U }; returns: null };
    "credentials.revoke_item": { args: { p_item: U; p_reason: string }; returns: null };
  }
}

/** Senha forte gerada no navegador (crypto): 20 caracteres sem ambíguos. */
export function generateSecret(length = 20): string {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%&*-_=+";
  const buf = new Uint32Array(length);
  crypto.getRandomValues(buf);
  return [...buf].map((n) => chars[n % chars.length]).join("");
}
